/* import __COLOCATED_TEMPLATE__ from './enforce-two-factor-auth-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();